import React from "react";
import {Col, Row, Card} from "antd";
import api from '@api/discount-code'
import Search from '@components/discountCodes/item/UsesReport/Search';
import Chart from '@components/discountCodes/item/UsesReport/Chart';
import List from '@components/discountCodes/item/UsesReport/List';
import whitListData from "@hocs/withListData";
import withPaginationComponent from '@hocs/withPaginationComponent';


function DiscountCodeUses(props) {
  const {data, isFetched, currentPage, search} = props;
  
  return (
    <Row gutter={16}>
      <Col span={24}>
        <Card className={`page-table-header`} bordered={false}>
          <Search search={search}/>
        </Card>
      </Col>
      <Col span={24} className={"page-table-wrapper"}>
        {/*{data.length > 0 && <Chart data={data}/>}*/}
    
        <List
          currentPage={currentPage}
          loading={!isFetched}
          data={data}/>
      </Col>
    </Row>
  )
}


export default whitListData(
  withPaginationComponent(DiscountCodeUses),
  {
    fetchRequest: api.getItemUses,
    paginationOnScroll: false
  }
);
